export default __webpack_public_path__ + "static/FAM16078000-a4da98e7178395476c58f4ac55ab86c9.jpg";